import styled from 'styled-components'

export const DateRangeContainer = styled.div`
  display: flex;
  margin: 0 1.5em;
`

export const MainContainer = styled.div<{ windowWidth: number }>`
  display: ${({ windowWidth }) => (windowWidth < 1324 ? 'block' : 'flex')};
  width: 100%;
`

export const SideContainers = styled.div`
  width: 100%;
  padding: 16px;
`

export const TopLeftContainer = styled.div<{ windowWidth: number }>`
  display: flex;
  justify-content: space-between;
  flex-direction: ${({ windowWidth }) =>
    windowWidth < 1340 ? 'column' : 'row'};
`

export const TopRightContainer = styled.div`
  display: flex;
`

export const BottomRightContainer = styled.div<{
  windowWidth: number
}>`
  padding: 8px;
  max-width: ${({ windowWidth }) => (windowWidth < 1400 ? '100%' : '508px')};
`

export const BottomLeftContainer = styled.div<{
  windowWidth: number
}>`
  padding: 8px;
  max-width: ${({ windowWidth }) => (windowWidth < 1400 ? '100%' : '508px')};
`

export const DashboardCardBottomLeftContainer = styled.div``

export const DashboardCardTopLeftContainer = styled.div<{
  windowWidth: number
}>`
  width: ${({ windowWidth }) => (windowWidth < 1340 ? '100%' : '50%')};
  padding: 8px;
`

export const DashboardCardTopRightContainer = styled.div<{
  windowWidth: number
}>`
  width: 100%;
  display: flex;
  flex-direction: ${({ windowWidth }) =>
    windowWidth < 1340 ? 'column' : 'row'};
`
export const DashBoardCardTitle = styled.p`
  font-weight: bold;
  font-family: Myraid Pro, sans-serif;
`

export const DashBoardBestSoldTitle = styled.p`
  font-weight: bold;
  font-family: Myraid Pro, sans-serif;
  margin: 10px 15px 5px 15px;
`
